import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ResolvableModal, Validators, WithModal } from '@softline/ui-core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { DateInputComponent } from '@softline/ui-core/date-input';
@Component({
  selector: 'soft-rohstoffbilanz-edit-zeitraum-form-dialog',
  imports: [ReactiveFormsModule],
  templateUrl: './edit-zeitraum-form-dialog.component.html',
  styleUrl: './edit-zeitraum-form-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class EditZeitraumFormDialogComponent extends ResolvableModal<{
  vondatum: string | null;
  bisdatum: string | null;
}> {
  readonly form = new FormGroup({
    vondatum: new FormControl<string | null>(null, Validators.required()),
    bisdatum: new FormControl<string | null>(null, Validators.required()) });

  set vondatum(value: string | null | undefined) {
    this.form.patchValue({ vondatum: value ?? null });
  }

  set bisdatum(value: string | null | undefined) {
    this.form.patchValue({ bisdatum: value ?? null });
  }

  constructor() {
    super();
  }
}
